import { ApiService } from "./apiService"

export const PageService =()=>{

        return{
            getPage: async (slug:string)=>{
                const response = await ApiService.get(`/api/items/pages?filter[slug][_eq]=${slug}&limit=1`);
                return response.data
            }
        }
}

